import client from 'data/client';
import { SummaryData } from 'data/types/summary';
import { normalizeSummary } from 'model/summary';

const getSummary = async (brandId: string) => {
  const response = await client.get<SummaryData>(
    `reporting/summary?brandId=${brandId}`,
  );
  return normalizeSummary(response.data);
};

export default getSummary;
